<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#6zali0s9ua)">
            <path
                d="M10.5 3h-9C.67 3 0 2.33 0 1.5S.67 0 1.5 0h9c.83 0 1.5.67 1.5 1.5S11.33 3 10.5 3zM12 6c0-.83-.67-1.5-1.5-1.5h-9C.67 4.5 0 5.17 0 6s.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zm0 4.5c0-.83-.67-1.5-1.5-1.5h-9C.67 9 0 9.67 0 10.5S.67 12 1.5 12h9c.83 0 1.5-.67 1.5-1.5z"
            />
        </g>
        <defs>
            <clipPath id="6zali0s9ua">
                <path d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
